module.exports = __webpack_public_path__ + "img/brandcenter.911a65db.svg";